import React from "react";
import { DashboardSidebar } from "./Sidebar";
import { useAuth } from 'providers/AuthContext';

export const DashboardTemplate = function ({ children }) {
  const { userInfo, isFetching } = useAuth();

  return (
    <div className="flex flex-wrap sm:flex-nowrap items-start w-[100vw] bg-background/light">
      <DashboardSidebar userInfo={userInfo} />
      { !isFetching && userInfo && (
        <div className="mt-[60px] sm:mt-0 md:flex md:items-start grow">
          <div className="grow rounded-md overflow-auto ml-2 sm:ml-0 mt-3 mr-3 mb-3 bg-white border-[1px] border-border/light p-3">
            {children}
          </div>
        </div>
      )}
    </div>
  );
};